export const NEGOTIATION_ROUTES = {
  get: '/b2b/negotiations',
  post: '/b2b/negotiations/',
  patch: '/b2b/negotiations/{id}',
  delete: '/b2b/negotiations/{id}',
};

export const NEGOTIATIONS_ROUTES = {
  get: '/b2b/negotiations/by-listing/{listingId}',
  patch: '/b2b/negotiations/{id}',
  post: '/b2b/negotiations/',
};

export const JOB_NEGOTIATIONS_ROUTES = {
  post: '/job-listings/negotiations/',
};

export const MSAAS_NEGOTIATIONS_BY_EMPLOYER_ROUTES = {
  get: '/b2b/negotiations/by-employer/{employerId}',
};

export const MSAAS_NEGOTIATION_BY_RESPONSE_ROUTES = {
  get: '/b2b/negotiations/by-response/{responseId}',
};

// [MCV-1646] Draft-first initial offer: load a draft scoped to either an
// existing JobResponse or a bare listing.
export const JOB_RESPONSE_NEGOTIATION_DRAFT_ROUTES = {
  get: '/job-responses/negotiation-draft',
};

// [MCV-1646] Submit the first negotiation for an existing JobResponse (the
// listing-level create path stays on `jobResponseBeginNegotiation`).
export const JOB_RESPONSE_INITIAL_NEGOTIATION_ROUTES = {
  post: '/job-responses/{responseId}/negotiations',
};

export const MSAAS_NEGOTIATION_CALCULATIONS_ROUTES = {
  post: '/b2b/negotiations/calculations',
};

export const JOB_NEGOTIATION_CALCULATIONS_ROUTES = {
  post: '/job-listings/negotiations/calculations',
};

export const MSAAS_NEGOTIATION_CONTRACT_SUMMARY_ROUTES = {
  post: '/b2b/negotiations/contract-summary',
};

export const MSAAS_NEGOTIATION_SHIFT_BREAKDOWN_ROUTES = {
  post: '/b2b/negotiations/shift-breakdown',
};
